import compact from 'lodash/compact';
const defaultKey = ['activity-obj'];
const keys = {
    default: defaultKey,
    activityObjId: (id) => compact([...defaultKey, id]),
    activityObj: (id, params) => {
        return compact([...defaultKey, id, params]);
    }
};
export default keys;
